import { ArticleModuleError } from '#components/Article/Modules/ArticleModuleError';
import { ErrorBoundary } from '#components/Error/ErrorBoundary';
import { notNullOrUndefined } from '#cutils/misc/notNullOrUndefined';
import type { ArticleData } from '#shared/types/article';

import styles from './ArticleBody.module.scss';
import { ArticleModule } from './Modules/ArticleModule';

type Props = {
	article: ArticleData;
	className?: string;
};

export function ArticleBody({ article, className = '' }: Props) {
	const mappedArticleModules = article.modules.nodes
		.filter(notNullOrUndefined)
		// The first module goes into the hero.
		.slice(1)
		.map((articleModule) => {
			return (
				<ErrorBoundary fallback={<ArticleModuleError />} key={articleModule.rowId}>
					<ArticleModule articleModule={articleModule} articlePublicationDate={article.publicationDate} articleRowId={article.rowId} />
				</ErrorBoundary>
			);
		});

	return (
		<section className={`${styles.section} ${className}`} id="articlebody">
			{mappedArticleModules}
		</section>
	);
}
